import React, {useState} from 'react';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import { useGrants } from '../../../Data/Business';
import { PageLoading } from '../../../Components/Loading';
import { classNames } from '../../../Services/helpers';
import Dropdown from '../../../Components/Dropdown';
import Toggle from '../../../Components/Button/Toggle';
import NoItems from '../../../Components/EmptyStates/NoItems';
import AddUser from './AddUser';
import { useDialogues } from '../../../Components/Dialogues';
import UpdateUser from './UpdateUser';
import Grant from '../../../Components/Formatting/Grant';

const statusClasses = {
    'Pending': 'bg-gray-200 text-gray-600',
    'Active': 'bg-brand text-white',
    'Revoked': 'bg-red-500 text-white',
};

const roleClasses = {
    'Owner': 'bg-brand text-white',
    'Manager': 'bg-brand-light text-white',
    'Worker':  'bg-orange-500 text-white',
}

const AdditionalUsers = () => {
    const {grants, removeUser, refresh} = useGrants(true);

    return <>
        <TopBar left="/more" title="Additional Users" />
        <Page>
            {grants ? <Inner {...{grants, refresh, removeUser}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({grants, refresh, removeUser}) => {
    const [showRevoked, setShowRevoked] = useState(false);
    const [addingUser, setAddingUser] = useState(false);
    const [updatingUser, setUpdatingUser] = useState(null);
    const {confirm} = useDialogues();

    return <>
        <Toggle label="Show removed users" enabled={showRevoked} onChange={setShowRevoked} hideFocusRing ring />

        <ul className="flex flex-col gap-y-2 divide-y mt-2 w-full">
            {grants.map(grant => {
                if (!showRevoked && grant.status === 'Revoked') {
                    return null;
                }
                if (grant.role === 'Owner') {
                    return null;
                }

                return <li key={grant.id} className={`w-full flex flex-row gap-x-2 py-3 justify-between items-center`}>
                    <Grant grantId={grant.id} size="10" />
                    <div className="grow flex flex-col justify-center pl-2 overflow-clip">
                        <p className={classNames('font-bold', grant.status === 'Revoked' && 'text-muted')}>
                            {grant.title}
                        </p>

                        {grant.title !== grant.email && <p>{grant.email}</p>}

                        <p>
                            <span className={classNames('px-2 py-1 rounded-full text-xs mr-2', roleClasses[grant.role])}>
                                {grant.role}
                            </span>
                            <span className={classNames('px-2 py-1 rounded-full text-xs mr-2', statusClasses[grant.status])}>
                                {grant.status}
                            </span>
                        </p>
                    </div>
                    <div className="shrink-0">
                        <Dropdown options={[
                            {
                                icon: 'Pencil',
                                title: 'Change role',
                                onClick: () => setUpdatingUser(grant),
                            },
                            {
                                icon: 'Trash',
                                title: 'Remove',
                                onClick: () => confirm(
                                    {
                                        theme: 'danger',
                                        title: 'Remove user',
                                        message: `Are you sure you want to remove ${grant.title} from this account?`,
                                    },
                                    () => removeUser(grant.id)
                                ),
                                disabled: grant.role === 'Owner' || grant.status === 'Revoked'
                            }
                        ]} />
                    </div>
                </li>
            })}
        </ul>

        <NoItems title="Add user"
            message={<>Add another user to user account.<br />Fees apply.</>}
            icon="User"
            onClick={() => setAddingUser(true)}
        />

        <AddUser isOpen={addingUser} setIsOpen={() => setAddingUser(false)} onChanged={refresh} />
        <UpdateUser isOpen={!!updatingUser} setIsOpen={() => setUpdatingUser(null)} onChanged={refresh} grant={updatingUser} />
    </>
}


export default AdditionalUsers;
